export default __webpack_public_path__ + "static/media/phone.cc3bf2f4.svg";